import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from '../../auth/auth.service';

@Component({
    selector: 'header-help',
    templateUrl: 'header-help.component.html',
    styleUrls: ['header-help.component.scss'],
    standalone: false
})
export class HeaderHelpComponent {
	@Input() helpId: string;
	@Input() helpVideos: any[] = [];
	@Input() helpMenuItems: any[] = [];
	@Input() helpUserGuides: any[] = [];

	@Output() openHelpMenuEditor = new EventEmitter();
	@Output() openHelpVideoEditor = new EventEmitter();
	@Output() closeHelpVideoEditor = new EventEmitter();

	public currentHelpVideo: any;
	public showModalBox = false;
	public showContentTypeVideo = false;
	public currentContentTypeVideo: any;

	public hasEditRight = false;

	constructor(private authService: AuthService, private sanitizer: DomSanitizer) {
		this.hasEditRight = this.authService.isInRole('PLATFORM_EDIT_HELP');
	}

	public isContentTypeVideo(helpVideo: any): boolean {
		return helpVideo.type === "content";
	}

	public openModalWithVideo(helpVideo: any): void {
		this.currentHelpVideo = {
			...helpVideo,
			url: this.sanitizer.bypassSecurityTrustResourceUrl(helpVideo.url + '?autoplay=1')
		};
		this.showModalBox = true;
	}

	public openContentTypeVideo(helpVideo: any): void {
		this.currentContentTypeVideo = this.sanitizer.bypassSecurityTrustHtml(helpVideo.content);
		this.showContentTypeVideo = true;
	}

	public closeModal(): void {
		this.showModalBox = false;
	}

	public closeContentTypeVideo(): void {
		this.showContentTypeVideo = false;
	}

	public onVideoClick(helpVideo: any): void {
		if (this.isContentTypeVideo(helpVideo)) {
			this.openContentTypeVideo(helpVideo);
		} else {
			this.openModalWithVideo(helpVideo);
		}
	}

	@HostListener('document:click', ['$event'])
	public documentClick(e: any): void {
		if (e.target && (e.target.className as any).includes && (e.target.className as any).includes('k-overlay')) {
			if (this.showModalBox) {
				this.showModalBox = false;
			}
			if (this.showContentTypeVideo) {
				this.showContentTypeVideo = false;
			}
		}
	}
}
